import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    count: 0,
    userInfo: null,
    searchVal:''
  },
  getters: {
  },
  mutations: {
    setCount(state, value) {
      state.count = value
    },
    setUserInfo(state, data) {
      state.userInfo = data
    },  
    setsearchVal(state, data){
      state.searchVal = data
    },
  },
  actions: {
  },
  modules: {
  },
});
